export default {
      id: "ar_arrivants-usage",
      viewBox: "0 0 140 100",
      url: "../dist/images/" + "sprite.svg#ar_arrivants-usage",
      toString: function () {
        return this.url;
      }
    }